module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "fm-title"
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }), _vm._v("Contents")]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/03_Foreword"
    }
  }, [_vm._v("Foreword by Nigel Cave")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/04_Bibliography"
    }
  }, [_vm._v("Bibliography")])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-para1"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/05_Chapter01"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter One")])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Hitler’s First Russian Winter")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/06_Chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Two")])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Rommel and The Fall of Tobruk")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/07_Chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Three")])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Tojo Attacks Pearl Harbor")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/08_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Four")])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Jap Onslaught in Southeast Asia")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/09_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Five")])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Tokyo Attacked –The Doolittle Revenge Raid")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/10_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Six")])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Battle of The Coral Sea and Battle of Midway")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/11_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Seven")])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v("British Target St Nazaire Dry Dock")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/12_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Eight")])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Operation Biting –The Bruneval Raid")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/13_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Nine")])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v("RAF Starts Area Bombing: Target Civilians")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/14_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Ten")])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v("Hitler Battles for the Caucasus Oilfields")])])]), _vm._v(" "), _c('h2', {
    staticClass: "toc-para"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/15_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "toc-num"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Chapter Eleven")])]), _c('span', {
    staticClass: "bold"
  }, [_vm._v("The Canadians Land at Dieppe")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9cef2874","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/toc.vue
// module id = 66
// module chunks = 0